<div class="view-selector" (click)="toggleDropDown($event)" (appClickOutside)="opened = false">
  <div class="view-selector__value">
    <span class="ellipsis">{{ selectedView?.name }}</span>
  </div>
  <span class="view-selector__arrow" [ngClass]="{ 'view-selector__arrow--up': opened }">
    <i class="icon-drop-arrow-down-table-default-16"></i>
  </span>
  <div class="view-selector__list-wrapper" *ngIf="opened">
    <div class="options-list">
      <ul>
        <li *ngFor="let view of allView" [class.selected]="view.id === selectedView.id" (click)="selectView(view)">
          <span>{{ view.name }}</span>
          <i *ngIf="view.isFavourite" class="icon-star-filled-16"></i>
        </li>
      </ul>
      <div class="options-list__divider">
        <div></div>
      </div>
      <div class="options-list__footer" (click)="allViewPreference()">{{'Translation.Allviews' | translate}}</div>
    </div>
  </div>
</div>
